
import { Component, OnInit, Output, EventEmitter , ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';


@Component({
    selector: 'app-cookiespage',
    templateUrl: './cookiespage.component.html',
    styleUrls: ['./cookiespage.component.scss'],
    standalone: false
})
export class CookiespageComponent implements OnInit {

  user:any

  constructor(private dataserv : DataService,
    private toastService : ToastService,private activemodel:NgbActiveModal,
    private currentUserService:CurrentUserService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.currentUserService.currentUser.subscribe((data)=>{
      if(data){
        this.user = data;
        this.cdr.detectChanges();
      }
    })
  }


  acceptCookies(stutas:boolean): void {
    var data = {
      "user_id": this.user.id,
      "status": stutas,
      "url":"/cookiespage"
    }
    this.dataserv.turmsandconditioncheck(data).subscribe((res) => {
      this.toastService.showSuccess('Cookie choice saved.', 'success');
      this.activemodel.close();
    
          this.cdr.detectChanges();});
  }

  declineCookies(stutas:boolean): void {
    var data = {
      "user_id": this.user.id,
      "status": stutas,
      "url":"/cookiespage"
    }
    this.dataserv.turmsandconditioncheck(data).subscribe((res) => {
      this.activemodel.close();
    
          this.cdr.detectChanges();});
  }
  
}
